export default __webpack_public_path__ + "static/media/Aura-Egg__63.17faf858.png";